const FLAG_OFFSET = 0x1f1e6 - 'A'.charCodeAt(0)

export function countryFlag(code) {
  if (!code || typeof code !== 'string') return ''
  const iso = code.trim().toUpperCase()
  if (iso.length !== 2 || !/^[A-Z]{2}$/.test(iso)) return ''
  return String.fromCodePoint(
    iso.charCodeAt(0) + FLAG_OFFSET,
    iso.charCodeAt(1) + FLAG_OFFSET
  )
}

export function userFlag(user) {
  return countryFlag(user?.country?.code)
}
